import e from "@dialpad/dialtone-tokens/layered/themes/tokens-114-colors.css?inline";
//#region themes/114.js
var t = { brand: {
	css: e,
	name: "114"
} };
//#endregion
export { t as default };
